<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header" *ngIf="!loadingSalesOpp">
    <h4 *ngIf="salesOpportunity?.ProfileID; else createHeader">
      {{
        salesOpportunity.SalesID
          ? ('sales-opportunities.edit.edit-header' | translate | titlecase)
          : ('sales-opportunities.edit.new-header' | translate | titlecase)
      }}
    </h4>
    <ng-template #createHeader>
      <h4>{{ 'sales-opportunities.edit.create-a-sales-opportunity' | translate | ucfirst }}</h4>
    </ng-template>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy [show]="loadingSalesOpp"></wl-busy>
  </div>
  <div class="dialog-body-container">
    <div [hidden]="salesOpportunity?.ProfileID || loadingSalesOpp">
      <p>{{ 'sales-opportunities.edit.search-prompt' | translate }}</p>
      <div>
        <wl-profile-quicksearch
          #quickSearch
          [suppressAutoSearch]="true"
          (keywordChange)="quickSearch.search()"
          (searchComplete)="setResults($event)"
        ></wl-profile-quicksearch>
      </div>
      <div *ngIf="profileResults">
        <wl-profile-results-grid
          [profiles]="profileResults"
          (onProfileSelected)="salesOppEdit.initWithProfile($event.ProfileId)"
        ></wl-profile-results-grid>
      </div>
    </div>
    <wl-sales-opportunity-edit
      #salesOppEdit
      [hidden]="!salesOpportunity?.ProfileID"
      [(salesOpportunity)]="salesOpportunity"
    ></wl-sales-opportunity-edit>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      class="atlas-btn atlas-btn-primary"
      *ngIf="salesOpportunity?.ProfileID"
      [disabled]="!salesOpportunity?.ItemNum || !salesOpportunity?.AssignedTo || isSaving"
      (click)="save()"
    >
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
